import "../components/About.css";


const About = ({ aboutRef }) => {
  return (
    <section className="about-premium" id="about-premium" ref={aboutRef}>
      <div className="about-container">

        {/* LEFT CONTENT */}
        <div className="about-left">
          <span className="pill">About Us</span>

          <h2>
            Turning <span>Ideas</span><br />
            Into Digital<br />
            Reality
          </h2>

          <p>
            At Code Inputs, we combine design, technology, and strategy
            to build scalable digital products. We don’t just write code —
            we create solutions that help businesses grow faster.
          </p>

          <div className="features">
            <div className="feature">
              <span>⚡</span>
              <div>
                <h4><b>Fast Delivery</b></h4>
                <p>Optimized workflows & clean code</p>
              </div>
            </div>

            <div className="feature">
              <span>🔒</span>
              <div>
                <h4><b>Secure Systems</b></h4>
                <p>Modern & secure architecture</p>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT VISUAL */}
        <div className="about-right">
          <div className="main-card">
            <h3>Why Code Inputs?</h3>
            <ul>
              <li>Startup-friendly approach</li>
              <li>Modern UI & UX</li>
              <li>Long-term support</li>
            </ul>
          </div>

          <div className="floating-box one"></div>
          <div className="floating-box two"></div>
        </div>

      </div>
    </section>
  );
};

export default About;
